import React from 'react'
import HeaderV2 from 'desktop/containers/layout/header_v2'

export default function HeaderContainer({ bannerHeightOffset }) {
  return <HeaderV2 bannerHeightOffset={bannerHeightOffset} />
}
